<div class="row filter-row">
    <div class="building-filter-col options-filter-col col-sm-3" *ngIf="!authenticationService.userIsResident">
        <search-select [ngModel]="optionsFilter"
                       name="optionsFilter"
                       (ngModelChange)="optionsFilterData($event)"
                       [data]="convertToOptionsFilter()" required>
        </search-select>
    </div>
    <div class="search-col"
         [ngClass]="{'col-sm-12' : authenticationService.userIsResident,'col-sm-6' : !authenticationService.userIsResident}">
        <div class="input-group search-field">
            <div class="search-field-wrapper">
                <input [(ngModel)]="searchString" type="text" placeholder="Search for {{tabHeading}}"
                       class="input form-control search-field__input" (input)="searchOnInput()" maxlength="300">
                <div class="input-group-btn search-field__button">
                    <button *ngIf="searchString" (click)="clearSearch()" class="btn btn btn-default clear-search">
                        <i class="fa fa-times"></i>
                    </button>
                    <div *ngIf="!searchString" class="btn btn btn-default bd-left-none"><i class="fa fa-search"></i>
                    </div>
                </div>
            </div>
            <div *ngIf="searchFields.length && !authenticationService.userIsResident" class="input-group-btn"
                 #searchFieldsBtn>
                <button type="button" class="btn btn-default dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu pull-right checkbox-list" (click)="$event.stopPropagation()">
                    <li *ngFor="let field of searchFields; let i = index">
                        <label class="img-checkbox">
                            <input type="checkbox" [(ngModel)]="field.isSelected" (change)="onSearchFieldChanged()"
                                   id="fieldCheckbox-{{i}}">
                            <label for="fieldCheckbox-{{i}}">
                                <svg-checked></svg-checked>
                            </label>
                            <span>{{field.name}}</span>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-sm-3 building-filter-col"
         *ngIf="convertedBuildings.length > 2 && !authenticationService.userIsResident">
        <search-select
            [placeholder]="placeholder"
            [ngModel]="selectedBuilding"
            name="selectedBuilding"
            (ngModelChange)="filterByBuilding($event);"
            [data]="convertedBuildings"
            searchProperty="searchProp"
            required>
            <ng-template
                searchSelectItem
                [approxHeight]="51"
                [approxWidth]="320"
                let-item="item"
                let-searchTerm="searchTerm"
                let-focused="focused"
            >
                <div class="building-select-item" [class.focus]="focused">
                    <div class="item-head">
                        <div class="item-name" *ngIf="item?.optionText">
                            <span ngxTextHighlight [content]="item.optionText"
                                  [searchTerm]="searchTerm" [caseSensitive]="false">
                               {{ item.optionText }}
                            </span>
                        </div>
                        <div *ngIf="item?.corporationNumberName" class="item-corp-number-name">
                            <span ngxTextHighlight [content]="item.corporationNumberName"
                                  [searchTerm]="searchTerm" [caseSensitive]="false">
                            {{ item.corporationNumberName }}
                            </span>
                        </div>
                    </div>
                    <div class="item-address" *ngIf="item?.address">
                        <span ngxTextHighlight [content]="item.address"
                              [searchTerm]="searchTerm" [caseSensitive]="false">
                            {{item.address}}
                        </span>
                    </div>
                </div>
            </ng-template>
        </search-select>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/filter/filter.component.html